import { Layers, Shirt, Tag, Sticker, Scissors, Printer, Palette, Package, Sparkles, Gift, Image as ImageIcon, Wrench, Truck, Star, Flag, BadgeDollarSign } from "lucide-react";

// Icons an admin can pick for a service card.
export const SERVICE_ICONS = { Layers, Shirt, Tag, Sticker, Scissors, Printer, Palette, Package, Sparkles, Gift, Image: ImageIcon, Wrench, Truck, Star, Flag, BadgeDollarSign };

export const ServiceIcon = ({ name, size = 18, className = "" }) => {
  const I = SERVICE_ICONS[name] || Sparkles;
  return <I size={size} className={className} />;
};
